package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Add
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue

import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.probes.ProbesScreen
import com.nonopn.skydome.common.app.pages.probes.openProbeCreation
import com.nonopn.skydome.common.app.pages.probes.rememberProbeCreationVisible
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_sr_probes
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem

import kotlinx.serialization.Serializable

import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters

@Serializable
object RouteProbes : RouteParameterTo

object RouterProbes : RouterNoParameters<RouteProbes>(RouteProbes::class) {
    override fun routeFrom(parameters: RouteProbes) = "/probes"

    @Composable
    override fun Show(parameters: RouteProbes) {
        RouteProbesImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteProbes,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteProbes

    override fun isMatching(route: String) = route == "/probes"

    override fun navigateFrom(path: String) = RouteProbes
}

class RouteProbesImpl : Route<RouteProbes>(
    route = "/probes",
    params = RouteProbes,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        // "+ Create" in the app bar, only while the creation feature is visible (flag / administrators)
        val creationVisible = rememberProbeCreationVisible(appModel)

        LaunchedEffect(creationVisible) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.menu_sr_probes,
                    actions = if (creationVisible) {
                        listOf(
                            MenuItem.MenuItemSimple(
                                imageVector = Icons.Rounded.Add,
                                onClick = { openProbeCreation(appModel, trial = false) }
                            )
                        )
                    } else {
                        emptyList()
                    }
                )
            )
        }

        val state by appModel.states.collectAsState()

        if (null == state.apiProvider?.apiNormal) return

        ProbesScreen()
    }
}
